import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import Permissoes from "./Permissoes";

const Index = ({ match, history }) => (
  <div className="content-wrapper">
    <Permissoes />
    <Switch>
      {/* <Redirect exact from={`${match.url}/`} to={`${match.url}/permissoes`} /> */}
      {/* <Route path={`${match.url}/permissoes`} component={Permissoes} /> */}
    </Switch>
  </div>
);

export default Index;
